import Header from '../../../Components/Header/Header';
import styles from './become-tenant.module.scss';
import { Helmet } from 'react-helmet-async';
import useInView from '../../../Components/UseInView/useInView';
import Footer from '../../../Components/Footer/Footer';
import InputField from '../../../Components/InputField/InputField';
import FileUpload from '../../../Components/FileUpload/FileUpload';
import Button from '../../../Components/Button/Button';
import { useState } from 'react';
import { submitMultipart } from '../../../Services/api.service';

const BecomeTenant = () => {
    const [applicationForm, setApplicationForm] = useState(ApplicationFormState);
    const [errors, setErrors] = useState({});
    const [submitted, setSubmitted] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [applicationRef, applicationVisible] = useInView();

    const handleFileSelect = (fileOrList) => {
        setApplicationForm((prev) => ({
            ...prev,
            documents: fileOrList,
        }));
    };

    const submitForm = async () => {
        if (applicationFormValidator(applicationForm, setErrors)) {
            setLoading(true);
            setSubmitted(true);
            try {
                const response = await submitMultipart(applicationForm);
                if (response.status === 200) {
                    setResponseMessage(response.data.message);
                }
            } catch (error) {
                if (error.response?.status === 405) {
                    setResponseMessage(error.response.data.message);
                } else {
                    setResponseMessage('There was a problem submitting your request.');
                }
            }
            setLoading(false);
        } else {
            setSubmitted(true);
            setResponseMessage('There was an error, check fields.');
        }
    };

    return (
        <>
            <Helmet>
                <title>Clear Property Management - Property Management Services</title>
                <meta name='description' content='We provide property management services.' />
                <link rel='canonical' href='/' />
            </Helmet>
            <Header />

            <p>[Become a Tenant]</p>
            <h1>Become a Tenant</h1>

            <div
                id='Applicationg Landing'
                ref={applicationRef}
                className={`${styles.applicationContainer} ${applicationVisible ? styles.visible : ''}`}
            >
                <div className={styles.innerApplication}>
                    <div className={styles.inputFieldWrapper}>
                        <InputField
                            required={true}
                            label='Full Name'
                            onChange={(e) =>
                                setApplicationForm({ ...applicationForm, name: e.target.value })
                            }
                            value={applicationForm.name}
                            error={errors.name}
                            customStyle={{ maxWidth: '400px' }}
                        />
                        <InputField
                            required={true}
                            label='Email'
                            onChange={(e) =>
                                setApplicationForm({ ...applicationForm, email: e.target.value })
                            }
                            value={applicationForm.email}
                            error={errors.email}
                            customStyle={{ maxWidth: '400px' }}
                        />
                    </div>
                    <div className={styles.inputFieldWrapper}>
                        <InputField
                            required={true}
                            label='Phone'
                            onChange={(e) =>
                                setApplicationForm({ ...applicationForm, phone: e.target.value })
                            }
                            value={applicationForm.phone}
                            error={errors.phone}
                            customStyle={{ maxWidth: '400px' }}
                        />
                        <InputField
                            required={true}
                            label='Current Address'
                            onChange={(e) =>
                                setApplicationForm({ ...applicationForm, address: e.target.value })
                            }
                            value={applicationForm.address}
                            error={errors.address}
                            customStyle={{ maxWidth: '400px' }}
                        />
                    </div>
                    <div className={styles.inputFieldWrapper}>
                        <InputField
                            required={true}
                            label='City'
                            onChange={(e) =>
                                setApplicationForm({ ...applicationForm, city: e.target.value })
                            }
                            value={applicationForm.city}
                            error={errors.city}
                            customStyle={{ maxWidth: '400px' }}
                        />
                        <InputField
                            required={true}
                            label='Employer Name'
                            onChange={(e) =>
                                setApplicationForm({ ...applicationForm, employer: e.target.value })
                            }
                            value={applicationForm.employer}
                            error={errors.employer}
                            customStyle={{ maxWidth: '400px' }}
                        />
                    </div>
                    <div className={styles.inputFieldWrapper}>
                        <InputField
                            required={true}
                            label='Job Title'
                            onChange={(e) =>
                                setApplicationForm({ ...applicationForm, jobTitle: e.target.value })
                            }
                            value={applicationForm.jobTitle}
                            error={errors.jobTitle}
                            customStyle={{ maxWidth: '400px' }}
                        />
                        <InputField
                            required={true}
                            label='Length of Employment'
                            onChange={(e) =>
                                setApplicationForm({
                                    ...applicationForm,
                                    lengthOfEmployment: e.target.value,
                                })
                            }
                            value={applicationForm.lengthOfEmployment}
                            error={errors.lengthOfEmployment}
                            customStyle={{ maxWidth: '400px' }}
                        />
                    </div>
                    <div className={styles.inputFieldWrapper}>
                        <InputField
                            required={true}
                            label='Income'
                            onChange={(e) =>
                                setApplicationForm({ ...applicationForm, income: e.target.value })
                            }
                            value={applicationForm.income}
                            error={errors.income}
                            customStyle={{ maxWidth: '400px' }}
                        />
                        <InputField
                            required={true}
                            label='Number of Occupants'
                            onChange={(e) =>
                                setApplicationForm({
                                    ...applicationForm,
                                    numberOfOccupants: e.target.value,
                                })
                            }
                            value={applicationForm.numberOfOccupants}
                            error={errors.numberOfOccupants}
                            customStyle={{ maxWidth: '400px' }}
                        />
                    </div>
                    <div className={styles.inputFieldWrapper}>
                        <InputField
                            required={true}
                            label='Pets'
                            onChange={(e) =>
                                setApplicationForm({ ...applicationForm, pets: e.target.value })
                            }
                            value={applicationForm.pets}
                            error={errors.pets}
                            customStyle={{ maxWidth: '400px' }}
                        />
                        <InputField
                            required={true}
                            label='Vehicle Information'
                            onChange={(e) =>
                                setApplicationForm({
                                    ...applicationForm,
                                    vehicleInformation: e.target.value,
                                })
                            }
                            value={applicationForm.vehicleInformation}
                            error={errors.vehicleInformation}
                            customClass={styles.customStyleForLastTwoInputFields}
                        />
                    </div>
                </div>

                <p>
                    Please upload the following supporting documents in PDF format. The total size
                    of all uploaded files should not exceed 25MB. These documents are required to
                    verify your identity and ability to pay rent.
                </p>
                <ul>
                    <li>Employment Letter</li>
                    <li>Driver's License or SIN #</li>
                    <li>Most Recent Bank Statement</li>
                </ul>
                <FileUpload onFileSelect={handleFileSelect} />

                <Button
                    buttonText='Submit Application'
                    displayIcon={true}
                    onClick={submitForm}
                    submitted={submitted}
                    loading={false}
                    responseMessage={responseMessage}
                    customStyle={{
                        alignSelf: 'center',
                        marginTop: 'min(10vw, 50px)',
                        marginBottom: 'min(5vw, 40px)',
                    }}
                />
            </div>

            <Footer />
        </>
    );
};

export default BecomeTenant;

const ApplicationFormState = {
    name: '', // no blank
    email: '', // regex
    phone: '', // regex
    address: '', // no blank
    city: '', // no blank
    employer: '', // no blank
    jobTitle: '', // no blank
    lengthOfEmployment: '', // no blank
    income: '', // no blank
    numberOfOccupants: '', // no blank
    pets: '', // no blank
    vehicleInformation: '', // no blank
    documents: '', // no blank
};

/**
 * Validate the application form.
 * @param {Object} formData  – current form values
 * @param {Function} setErrors – React state setter: errors => void
 * @returns {boolean}        – true if form is valid
 */
export const applicationFormValidator = (formData, setErrors) => {
    const {
        name,
        email,
        phone,
        address,
        city,
        employer,
        jobTitle,
        lengthOfEmployment,
        income,
        numberOfOccupants,
        pets,
        vehicleInformation,
        documents,
    } = formData;

    // patterns
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9+\-\s()]{7,20}$/; // digits, +, -, space, parentheses

    // detect “blank” the same way everywhere
    const isBlank = (v) => v == null || (typeof v === 'string' ? v.trim() === '' : false);

    // build error map
    const errors = {
        name: isBlank(name),
        email: isBlank(email) || !emailRegex.test(email),
        phone: isBlank(phone) || !phoneRegex.test(phone),
        address: isBlank(address),
        city: isBlank(city),
        employer: isBlank(employer),
        jobTitle: isBlank(jobTitle),
        lengthOfEmployment: isBlank(lengthOfEmployment),
        income: isBlank(income),
        numberOfOccupants: isBlank(numberOfOccupants),
        pets: isBlank(pets),
        vehicleInformation: isBlank(vehicleInformation),
        // for documents accept FileList, array, or non-empty string
        documents:
            documents == null ||
            (typeof documents === 'string' && documents.trim() === '') ||
            (documents instanceof FileList && documents.length === 0) ||
            (Array.isArray(documents) && documents.length === 0),
    };

    // expose errors to UI
    setErrors(errors);

    // overall validity
    return !Object.values(errors).some(Boolean);
};
